'use client'
import Page from '#/app/(blank)/maintenance/page';

// eslint-disable-next-line no-unused-vars
export default function Error({ error, reset }) {
  return <Page />;
}
